@if (showSectionsMenu) {
  <div class="section-menu">
    <div class="section-menu__container">
      <div class="section-menu__content">
        <ul class="section-menu__sections">
          @for (sec of sectionMenuContainer.sections; track $index) {
            <li>
              @if (sec.name !== 'updated') {
                <a (click)="onClick(sec.name)">
                  <span
                    class="text-primary-hover bold"
                    [ngClass]="{'text-primary': sec.name === sectionMenuContainer.currentSectionInViewPort}"
                  >
                    {{ sec.title | translate }}
                  </span>
                </a>
              }
            </li>
          }
        </ul>

        <span class="section-menu__object-name bold">
          <app-object-icon
            [object]="sectionMenuContainer.artifact"
          ></app-object-icon>

          <app-object-name
            [object]="sectionMenuContainer.artifact"
            [dontApplyWordBreak]="true"
          ></app-object-name>
        </span>
      </div>
    </div>
  </div>
}
